import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { Subject } from 'rxjs/Subject';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
//import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ChallanOutService, CommonService, SubscribeService } from '../../../services/index';
import { ChallanOutModel, EmployeeModel, ClientModel } from '../../../model/index';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'addchallanout-tab',
    templateUrl: './addEditChallanOut.component.html',
})
export class AddEditChallanOutComponent implements OnInit {
    private searchTermsEmp = new Subject<string>();
    private searchTermsCli = new Subject<string>();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    public challanoutsdata: any[] = [];

    isLoadMask: Promise<any>;
    pocData: ChallanOutModel[];
    isLoading: boolean = false;

    @Output() challanoutUpdateEvent = new EventEmitter();


    @Input() challanoutdata: ChallanOutModel[] = [];
    @Input() challangriddata: ChallanOutModel[] = [];
    @Input() testingbilldata: ChallanOutModel[] = [];

    emplistCtrl: FormControl;
    filteredEmp: Observable<any[]>;
    halistCtrl: FormControl;
    filteredHa: Observable<any[]>;
    testingbillCtrl: FormControl;
    filteredItems: Observable<any[]>;
    filteredSerialNo: Observable<any[]>;
    serialNoCtrl: FormControl;
    @ViewChild('emplistAutoComp') emplistAutoComp;
    @ViewChild('halistAutoComp') halistAutoComp;
    @ViewChild('testingbillAutoComp') testingbillAutoComp;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    empList: any[] = [];
    haList: any[] = [];
    clientList: any[] = [];
    testingList: any[] = [];
    serialNoList: any[] = [];
    actSerialNoList = [];

    constructor(private challanoutService: ChallanOutService, private commonService: CommonService, public snackBar: MdSnackBar, public toasterService: ToasterService, public subscribeService: SubscribeService) {

        // this.emplistCtrl = new FormControl();
        //this.testingbillCtrl = new FormControl();

        function hasValidTest(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidTest: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidTest: true };
            }
            return retVal;
        }
        this.testingbillCtrl = new FormControl('', [
            Validators.required,
            hasValidTest.bind(this)
        ]);

        function hasValidEmp(input: FormControl) {
            let empid = input.value;
            let femp = _.find(this.empList, { 'empid': empid });
            if (femp)
                return null;
            return { inValidEmp: true };
        }
        this.emplistCtrl = new FormControl('', [
            Validators.required,
            hasValidEmp.bind(this)
        ]);

        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;
            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);
        //  this.halistCtrl = new FormControl();
        this.filteredHa = this.halistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterHa(name) : this.haList.slice());

        function hasValidSerial(input: FormControl) {

            let SerialID = input.value, retVal = null;
            if (SerialID == "") {
                retVal = { inValidSerial: true };
            }
            let fhalist = _.find(this.serialNoList, { 'serial_no': SerialID });
            if (!fhalist) {
                retVal = { inValidSerial: true };
            }
            return retVal;
        }

        this.serialNoCtrl = new FormControl('', [
            Validators.required,
            hasValidSerial.bind(this)
        ]);
        // this.serialNoCtrl = new FormControl();
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());


        let that = this;
        //FOR EMPLOYEE COMBO
        this.filteredEmp = this.searchTermsEmp
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.getEmployeeList(term, 'challan')
                // or the observable of empty heroes if there was no search term
                : Observable.of<EmployeeModel[]>([]))
            //.switchMap(term => this.commonService.getEmployeeList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<EmployeeModel[]>([]);
            });
        this.filteredEmp = this.emplistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterEmp(name) : this.empList.slice());
    }

    reorderable: boolean = true;
    page = {
        limit: 100,
        count: 0,
        offset: 0,
        orderBy: 'challan_out_id',
        orderDir: 'asc'
    };
    columns = [];
    minDate: any;
    challanDetails = [];
    totalDetails = [];
    challanoutdetail = [];
    ngOnInit(): void {
        let that = this;
        this.loadChallanHaList();
        this.loadEmpList();
        this.halistAutoComp.optionSelected.subscribe(this.onSelectedHaList.bind(this));

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model Name', prop: 'name', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Serial No.', prop: 'serial_no', width: 150, minWidth: 150, maxWidth: 150 },
            { name: 'Quantity', prop: 'quantity', width: 100, minWidth: 100, maxWidth: 100, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno', width: 90, minWidth: 90, maxWidth: 90, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.filteredItems = this.searchTermsCli
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'challan')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            //.switchMap(term => this.commonService.getEmployeeList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

        if (this._params['mode'] == 'Add') {
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.challanoutdata['date'] = new Date();
        }
    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'challanOut',
                date: moment(this.challanoutdata['date']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function (res: any) {
                if (res['success']) {
                    that.challanoutdata['challan_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }
    searchEmployee(query: string) {
        this.searchTermsEmp.next(query);
    }

    filterEmp(name: string) {
        name = _.escapeRegExp(name);
        return this.empList.filter(emp => (new RegExp(name, 'gi').test(emp.empname)));
    }
    loadEmpList() {
        let that = this,
            data = {
                name: '',
                type: 'challan'
            };
        this.commonService
            .getEmployeeName(data)
            .then(function (res: any) {
                that.empList = res['data'];
                // that.actSerialNoList = res['haModelStockSerial'];
                that.emplistCtrl.setValue(that.challanoutdata['empid']);
                //that.emplist2Ctrl.setValue(that.clientFollowDet['empid']);
            });
    }
    displayEmp(empID: number) {
        if (empID && this.empList.length > 0) {
            let femp = _.find(this.empList, { 'empid': empID });
            this.challanoutdata['emp_name'] = femp.empname;
            return femp['empname'];
        }
        return '';
    }
    ilterEmp(empname: string) {
        empname = _.escapeRegExp(empname);
        return this.empList.filter(ha => (new RegExp(empname, 'gi').test(ha.empid)
            || new RegExp(empname, 'gi').test(ha.empname)));
    }
    loadChallanHaList() {
        let that = this,
            data = {
                stock_type: 'HA MODEL'
            };
        this.commonService
            .getHaModelStock(data)
            .then(function (res: any) {
                that.haList = res['haStockModel'];
                that.actSerialNoList = res['haModelStockSerial'];
                that.halistCtrl.setValue(that.challangriddata['model_id']);
            });
    }

    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    displayHa(challan_out_id: number) {

        if (challan_out_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'model_id': challan_out_id });
            //this.challangriddata['avail_qty'] = fhalist.avail_qty;
            this.getModelSerialNo(challan_out_id);
            return fhalist['name'];
        }
        return '';
    }
    getModelSerialNo(modelID) {
        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, { 'model_id': modelID });
        this.serialNoCtrl.setValue(this.challangriddata['serial_no']);
    }
    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }

    displaySerialNo(serial_no: number) {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no });
            // this.challangriddata['mrp'] = fhalist.mrp;
            this.challangriddata['challan_out_id'] = fhalist.challan_out_id;
            this.challangriddata['serial_no'] = fhalist.serial_no;
            this.challangriddata['avail_qty'] = fhalist.avail_qty;

            //this.challangriddata['quantity'] = 1;
            return fhalist['serial_no'];
        }
        return '';
    }
    onSelectedHaList(mdCompEvent: any) {
        let challan_out_id = mdCompEvent.option.value,
            fhalist = _.find(this.haList, { 'model_id': challan_out_id });

        this.challangriddata['name'] = fhalist.name;
    }
    searchClient(query: string) {
        this.searchTermsCli.next(query);
    }

    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.clientList.filter(client => (new RegExp(name, 'gi').test(client.client_code) || new RegExp(name, 'gi').test(client.client_no)));
    }

    displayFn(clientID: number) {
        if (clientID && this.clientList.length > 0) {
            let fclient = _.find(this.clientList, { 'client_id': clientID });
            this.challanoutdata['client_name'] = fclient.client_name;
            return fclient['client_no'];
        }
        return '';
    }
    setPageData(): void {

        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.challanoutdata = Object.assign({}, this._params);
            if (mode == 'Edit') {
                this.challanoutdata['hidden_emp'] = this._params['empcode'];
                this.challanoutdata['hidden_client'] = this._params['client_no'];
                this.challanoutdata['date'] = new Date(this._params['date']);

                this.getChallanOutModelDetails();
            } else if (mode == 'View') {
                this.challanoutdata['hidden_emp'] = this._params['empcode'];
                this.challanoutdata['hidden_client'] = this._params['client_no'];
                this.challanoutdata['date'] = new Date(this._params['date']);

                this.getChallanOutModelDetails();
            }
        }
    }
    /**
     * Called whenever the user changes page
     */
    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        this.page.offset = pageInfo.offset;
        this.getChallanOutModelDetails();
    }
    getChallanOutModelDetails(): void {

        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderBy: 'challan_out_id',
            orderDir: `${this.page.orderDir}`,
            challan_out_id: this.challanoutdata['challan_out_id']
        };

        let that = this;
        
        this.isLoadMask = this.challanoutService
            .getChallanOutModelDetails(params)
            .then(function (res: any) {

                that.page.count = res.totCnt;
                that.challanDetails = res.data;
            });
    }

    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    // pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    //     this.page.offset = pageInfo.offset;
    //     this.getChallanOutModelDetails();
    // }

    onDeleteChallanout(row: any): void {
        let that = this,
            mode = this.challanoutdata['mode'];
        if (mode == 'Add') {
            this.challanDetails.splice(this.challanDetails.indexOf(row), 1);
            this.challangriddata = [];
        } else if (mode == 'Edit') {
            let params = {
                model_id: row.model_id,
                name: row.name,
                quantity: row.quantity,
                avail_qty: row.avail_qty,
                challan_out_id: row.challan_out_id,
                serial_no: row.serial_no
            };
            this.challanoutService
                .deleteChallanModel(params)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.challanDetails.splice(that.challanDetails.indexOf(row), 1);
                    } else {

                        swal('ERROR', res.message, 'error');
                    }
                })
        }
    }

    addChallanout(): void {
        let that = this,
            mode = this.challanoutdata['mode'],
            modelID = this.challangriddata['model_id'],
            serialNo = this.challangriddata['serial_no'];

        if (!_.isEmpty(_.toString(modelID))) {//if (modelID != undefined) {
            //IF preModelObj FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preModelObj = _.find(this.challanDetails, { 'model_id': modelID, 'serial_no': serialNo });

            if (preModelObj) {
                let modelname = this.challangriddata['name'];
                swal('WARNING', 'Model : ' + modelname + ', Serial NO: ' + serialNo + '  Already Exists');
                return;
            }
            let avail_qty = this.challangriddata['avail_qty'],
                qty = this.challangriddata['quantity'];

            if (parseFloat(qty) > parseFloat(avail_qty)) {/// 10 > 11
                swal('WARNING', 'Entered Quantity is More than Available Quantity');
                return;
            }
            if (_.isEmpty(_.toString(this.challangriddata['quantity'])) || this.challangriddata['quantity'] <= 0) {
                swal('WARNING', 'Please Select Quantity OR more than ZERO');
                return;
            }

            if (mode == 'Add') {
                let testDet = Object.assign({}, this.challangriddata);
                this.challanDetails.push(testDet);
                this.challangriddata = [];
                that.page.count = this.challanDetails.length;
            } else if (mode == 'Edit') {
                let testDet = Object.assign({}, this.challangriddata),
                    params = {
                        model_id: this.challangriddata['model_id'],
                        name: this.challangriddata['name'],
                        quantity: this.challangriddata['quantity'],
                        avail_qty: this.challangriddata['avail_qty'],
                        challan_out_id: this.challanoutdata['challan_out_id'],
                        serial_no: that.challangriddata['serial_no']
                    };
                this.challanoutService
                    .addChallanOutModel(params)
                    .then(function (res: any) {
                        that.isLoading = false;
                        if (res.success) {

                            swal('SUCCESS', res.message, 'success');
                            //that.testingbillUpdateEvent.emit();
                            that.challangriddata = [];
                            that.challanDetails.push(testDet);
                            that.page.count = that.challanDetails.length;

                            //that.getTestingbillDetailList();

                        } else {
                            swal('ERROR', res.message, 'error');
                        }
                    })
            }
        }
    }
    onSaveChallanout(): void {
        let that = this,
            mode = this.challanoutdata['mode'],
            testingDet = this.challanDetails.length,
            toast = {
                type: 'warning',
                title: 'WARNING'
            };
        /*  if (_.isEmpty(this.challanoutdata['empid'])) {
             debugger;
             toast['body'] = 'Please Select Employee';
             this.toasterService.pop(toast);
             return;
         } */
        /*  if (_.isEmpty(_.toString(this.challanoutdata['client_id']))) {
              toast['body'] = 'Please Select Client';
              this.toasterService.pop(toast);
              return;
          }*/
        if (testingDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Model Details');
            return;
        }

        let challanOutDate = moment(this.challanoutdata['date']).format('YYYY-MM-DD'),
            params = {
                challan_out_id: this.challanoutdata['challan_out_id'],
                challan_no: this.challanoutdata['challan_no'],
                date: challanOutDate,
                empid: this.challanoutdata['empid'],
                client_id: this.challanoutdata['client_id'],
                client_name: this.challanoutdata['client_name'],
                challanDetails: JSON.stringify(this.challanDetails),
                mode: this._params['mode']
            };
        this.isLoading = true;
        this.challanoutService
            .addUpdateChallanout(params)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.subscribeService.subReloadChallanOutListGrid();
                    that.challanoutdata = [];
                    that.challanDetails = [];
                    that.subscribeService.subScribeDeleteActiveTab();
                } else {
                    that.snackBar.open(res.message);
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };
                    that.toasterService.pop(toast);
                }
            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/challanOut/addEditChallanOut.component.ts